/**
 * @generated SignedSource<<1119ba7133c70a101be1f413f4cbcbcd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApproveDownloadDialog_survey$data = {
  readonly id: string;
  readonly resultsUnlocked: boolean;
  readonly " $fragmentType": "ApproveDownloadDialog_survey";
};
export type ApproveDownloadDialog_survey$key = {
  readonly " $data"?: ApproveDownloadDialog_survey$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApproveDownloadDialog_survey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApproveDownloadDialog_survey",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultsUnlocked",
      "storageKey": null
    }
  ],
  "type": "ProjectSurvey",
  "abstractKey": null
};

(node as any).hash = "771caad5ee044d6e45efccf20b828b04";

export default node;
